import { z } from 'zod'

import { blockOf, mediaIdSchema, mediaSchema, subListItemOf } from './common'
import { BlockType } from './types'

export const GALLERY_MAX_IMAGES = 24

export const galleryImageSchema = z.object({
    ...subListItemOf(),
    mediaId: mediaIdSchema,
    media: mediaSchema,
    caption: z.string(),
})

export type GalleryImage = z.infer<typeof galleryImageSchema>

export const galleryBlockSchema = z.object({
    ...blockOf(BlockType.GALLERY),
    title: z.string(),
    images: z
        .array(galleryImageSchema)
        .max(GALLERY_MAX_IMAGES, 'admin.cms.blocks.errors.galleryTooManyImages'),
})

export type GalleryBlockData = z.infer<typeof galleryBlockSchema>
